














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { addClass, removeClass } from '@tencent/s2-client-vue-lib';
import { settingsModule } from '@/store/modules/ModuleSettings';

@Component({
	name: 'RightPanel'
})
/** RightPanel */
export default class RightPanel extends Vue {
	@Prop({
		default: false
	})
	private clickNotClose!: boolean;

	@Prop({
		default: 250
	})
	private buttonTop!: number;

	/** 声明数据状态 */
	private show: any = false;

	/** document hooks */
	private get theme(): any {
		return settingsModule.theme;
	}

	/** document hooks */
	@Watch('show')
	private onShowChange(value: boolean): any {
		if (value && !this.clickNotClose) {
			this.addEventClick();
		}

		if (value) {
			addClass(document.body, 'showRightPanel');
		} else {
			removeClass(document.body, 'showRightPanel');
		}
	}

	/** document hooks */
	public mounted(): any {
		this.insertToBody();
	}

	/** document hooks */
	public beforeDestroy(): any {
		const elx: any = this.$refs.rightPanel as Element;

		elx.remove();
	}

	/** document hooks */
	private addEventClick(): any {
		window.addEventListener('click', this.closeSidebar.bind(this));
	}

	/** document hooks */
	private closeSidebar(ev: MouseEvent): any {
		const parentTarget: any = ev.target;
		const parent: any = parentTarget.closest('.rightPanel');

		if (!parent) {
			this.show = false;
			window.removeEventListener('click', this.closeSidebar.bind(this));
		}
	}

	/** document hooks */
	private insertToBody(): any {
		const elx: any = this.$refs.rightPanel as Element;
		const body: any = document.querySelector('body');

		if (body) {
			body.insertBefore(elx, body.firstChild);
		}
	}
}
